import React, { useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import "moment/locale/fr";
import { getCandidate } from "../../redux/actions/admin/CandidateActions";
import localStorageService from "../../services/localStorageService";
import EducationResume from "./resume/EducationResume";
import ExperienceResume from "./resume/ExperienceResume";
import SkillResume from "./resume/SkillResume";
import LanguageResume from "./resume/LanguageResume";
import ReferenceResume from "./resume/ReferenceResume";
import ResumeSummary from "./resume/ResumeSummary";

let CandidateResume = (props) => {
  const { storeCandidate, getCandidate } = props;
  const [candidateId, setCandidatId] = React.useState("");
  const [CandidateEducationsList, setCandidateEducationsList] = React.useState(
    null
  );
  const [
    CandidateExperiencesList,
    setCandidateExperiencesList,
  ] = React.useState(null);
  const [CandidateLanguagesList, setCandidateLanguagesList] = React.useState(
    null
  );
  const [CandidateReferencesList, setCandidateReferencesList] = React.useState(
    null
  );
  const [candidateSkillsList, setCandidateSkillsList] = React.useState(null);
  const [candidate, setCandidate] = React.useState(null);
  const [candidateSummary, setCandidateSummary] = React.useState(
    {
      description: "",
      title: ""
    });
  useEffect(() => {
    let candidate = localStorageService.getItem("malibaara_auth_candidate");
    if (candidate) {
      setCandidatId(candidate.id);
    }

    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (candidateId != "") {
      if (storeCandidate.candidate === null) {
        getCandidate(candidateId).then((resp) => {
          setCandidate(resp);
          setCandidateEducationsList(resp.educations);
          setCandidateExperiencesList(resp.workExperiences);
          setCandidateSkillsList(resp.skills);
          setCandidateLanguagesList(resp.languages);
          setCandidateReferencesList(resp.references);
          setCandidateSummary((prevState) => ({
            ...prevState,
            description: resp.summaryDescription,
            title: resp.summaryTitle,
          }));
        });
      } else if (storeCandidate.candidate !== null) {
        setCandidate(storeCandidate.candidate);
        setCandidateEducationsList(storeCandidate.candidate.educations);
        setCandidateExperiencesList(storeCandidate.candidate.workExperiences);
        setCandidateSkillsList(storeCandidate.candidate.skills);
        setCandidateLanguagesList(storeCandidate.candidate.languages);
        setCandidateReferencesList(storeCandidate.candidate.references);
        setCandidateSummary((prevState) => ({
          ...prevState,
          description: storeCandidate.summaryDescription,
          title: storeCandidate.summaryTitle,
        }));
      }
    }
  }, [candidateId]);

  useEffect(() => {
    console.log("tittre", candidate?.summaryTitle);
    console.log("summary", candidate?.summaryDescription);
  }, [candidate]);

  return (
    <React.Fragment>
      <div className="col-lg-8">
        <div className="col-lg-12  pt-4 mt-lg-10">
          <ResumeSummary summary={candidateSummary} />
        </div>
        <div className="col-lg-12  pt-4 mt-lg-10">
          <EducationResume educationList={CandidateEducationsList} />
        </div>
        <div className="col-lg-12  pt-4 mt-lg-10">
          <ExperienceResume experienceList={CandidateExperiencesList} />
        </div>
        <div className="col-lg-12  pt-4 mt-lg-10">
          <SkillResume skillList={candidateSkillsList} />
        </div>
        <div className="col-lg-12  pt-4 mt-lg-10">
          <LanguageResume languageList={CandidateLanguagesList} />
        </div>
        <div className="col-lg-12  pt-4 mt-lg-10">
          <ReferenceResume referenceList={CandidateReferencesList} />
        </div>
      </div>
    </React.Fragment>
  );
};

CandidateResume.propTypes = {
  storeCandidate: PropTypes.object.isRequired,
  getCandidate: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  storeCandidate: state.candidate,
});

export default connect(mapStateToProps, {
  getCandidate,
})(CandidateResume);
